import { defineNuxtPlugin } from "#app";    
import VOtpInput from "vue3-otp-input";
export default defineNuxtPlugin((nuxtApp: any) => {
    nuxtApp.vueApp.component('v-otp-input', VOtpInput  )
})